"use strict";
// TODO: we need to delete this file when this interface will be not used.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=EndpointDescriptor.js.map